import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

interface DisplayCard {
  image: string;
  title: string;
}

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max on a Display Network site (mobile): a carousel of three
 * cards inside the page, with the long headline under it. The hotel cards
 * are static placeholders; they are not template fields.
 */
@Component({
  selector: 'app-pmax-display-mobile-01',
  imports: [CommonModule, MobileFrameComponent],
  templateUrl: './display-mobile-01.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-mobile-01.component.scss'
})
export class PmaxDisplayMobile01PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton text lines above and below the ad, as % widths. */
  readonly linesAbove = [100, 100, 100, 100, 100, 100, 100, 100, 65];
  readonly linesBelow = [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100];

  readonly cards: DisplayCard[] = [
    { image: HOTELS + 'lacroma.jpg', title: 'Valamar Lacroma Hotel' },
    { image: HOTELS + 'san-marino.jpg', title: 'San Marino Hotel' },
    { image: HOTELS + 'parentino.jpg', title: 'Valamar Parentino Hotel' },
  ];

  get longHeadline(): string {
    return this.data.longHeadlines[0] || 'Your long headline appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
